function StatsSection() {
  const stats = [
    { value: '250', suffix: '+', label: 'Entreprises inscrites' },
    { value: '5', suffix: '', label: 'Villes couvertes' },
    { value: '12', suffix: 'k+', label: 'Utilisateurs actifs' },
    { value: '20', suffix: '+', label: 'Catégories' },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-100 border-y border-background-200/70">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="font-heading font-bold text-3xl md:text-4xl text-primary-400 mb-2">
                {stat.value}{stat.suffix}
              </div>
              <div className="text-sm text-foreground-400">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StatsSection;